export const numberWithNoExponents = num => {
  const data = String(num).split(/[eE]/)
  if (data.length === 1) return data[0]

  let z = ''
  let mag = Number(data[1]) + 1
  const sign = num < 0 ? '-' : ''
  const str = data[0].replace('.', '')

  if (mag < 0) {
    z = sign + '0.'
    while (mag++) z += '0'
    return z + str.replace(/^-/, '')
  }
  mag -= str.length
  while (mag--) z += '0'
  return str + z
}

export const toFixed = (num, precision = 2) =>
  String(num)
    .split('.')
    .map((val, i) => (i !== 0 ? val.slice(0, precision) : val))
    .join('.')

const SEPARATORS = {
  EU: {
    decimal: ',',
    thousands: '.',
  },
  US: {
    decimal: '.',
    thousands: ',',
  },
}

export const getCurrencySeparators = function ({code = null, symbol = null}) {
  const identifier = code || symbol

  if (identifier === 'EUR' || identifier === '€') {
    return SEPARATORS.EU
  }

  return SEPARATORS.US
}

export const formatFloatNumber = ({
  value,
  float = true,
  floatPrecision = 2,
  separators = SEPARATORS.US,
}) => {
  const isNegative = value < 0
  let valueStr = float ? toFixed(numberWithNoExponents(value), floatPrecision) : numberWithNoExponents(value)
  let [intPart] = valueStr.split('.')
  let floatPart = valueStr.split('.')[1] || '00'

  intPart = intPart
    .split('')
    .filter(char => char !== '-')
    .reduceRight((acc, res, index, arr) => {
      if ((arr.length - index - 1) % 3 === 0) {
        return res + separators.thousands + acc
      }
      return res + acc
    })

  floatPart = Array(floatPrecision)
    .fill('0')
    .map((num, index) => (index < floatPart.length ? floatPart[index] : num))
    .join('')

  valueStr = (isNegative ? '-' : '') + intPart + (float && floatPart ? separators.decimal + floatPart.padEnd(1, '0') : '')

  return valueStr
}
